import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProjektItem } from './projekt.model';
import {CollectionApiResponse} from '../../../lib/util/api-response';
import {MitarbeiterItem} from '../Mitarbeiterverwaltung/mitarbeiter.model';
import {FilterItem} from './filter.model';
import {NodeItem} from './node.model';

type Projekte = CollectionApiResponse<ProjektItem>;
type Nodes = CollectionApiResponse<NodeItem>;

@Injectable()
export class ProjektService {
    /**
     * Constructor of address service
     *
     * @param http - The http client
     */
    constructor(private http: HttpClient) {}

    /**
     * Returns a list of addresses
     *
     * @returns - An observable that emits the response
     */
    public getAllProjekte(): Observable<Projekte> {
      console.log('still used');
      // tslint:disable-next-line:max-line-length
      return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/getAllProjekte.php?${sessionStorage.getItem('session')}`) as Observable<
          Projekte
        >;
    }

  public addProjekt(item: ProjektItem): Observable<ProjektItem> {
    // tslint:disable-next-line:max-line-length
      return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/addProjekt.php?${sessionStorage.getItem('session')}`, item) as Observable<
      ProjektItem
      >;
  }

  public pasteProjekt(item: NodeItem, copyNodes: NodeItem[]): Observable<NodeItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.post
    (
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/pasteProjekt.php?${sessionStorage.getItem('session')}`
      , [copyNodes, item]
    ) as Observable<
      NodeItem
      >;
  }

  public addProjektstufe(item: NodeItem): Observable<NodeItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/addProjektstufe.php?${sessionStorage.getItem('session')}`, item) as Observable<
      NodeItem
      >;
  }

  public deleteProjekt(item: NodeItem): Observable<number> {
    // tslint:disable-next-line:max-line-length
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/deleteProjekt.php?${sessionStorage.getItem('session')}`, item) as Observable<
      number>;
  }

  public archiveProjekt(item: NodeItem): Observable<number> {
    // tslint:disable-next-line:max-line-length
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/archiveProjekt.php?${sessionStorage.getItem('session')}`, item) as Observable<
      number>;
  }

  public dearchiveProjekt(item: NodeItem): Observable<number> {
    // tslint:disable-next-line:max-line-length
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/dearchiveProjekt.php?${sessionStorage.getItem('session')}`, item) as Observable<
      number>;
  }

  public editProjekt(projekt: NodeItem): Observable<NodeItem> {
    return this.http.put(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/editProjekt.php?${sessionStorage.getItem('session')}`,
      projekt,
    ) as Observable<NodeItem>;
  }

  public editProjektstufe(projekt: NodeItem): Observable<NodeItem> {
    return this.http.put(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/editProjektstufe.php?${sessionStorage.getItem('session')}`,
      projekt,
    ) as Observable<NodeItem>;
  }

  public getFilteredProjekte(filterOption: string, item: FilterItem): Observable<Nodes> {
      const filter = filterOption;
      const filterItem = item;
      // tslint:disable-next-line:max-line-length
      return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/getFilteredProjekte.php?${sessionStorage.getItem('session')}&filter=${filter}`, filterItem) as Observable<
        Nodes
      >;
  }

  public getAllNodes(archive: number): Observable<Nodes> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/getAllNodes.php?${sessionStorage.getItem('session')}&archive=${archive}`) as Observable<
      Nodes
      >;
  }
  public getCopyNodes(projekt: NodeItem): Observable<Nodes> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/getCopyNodes.php?${sessionStorage.getItem('session')}`, projekt) as Observable<
      Nodes
      >;
  }
  public getUserNodes(): Observable<Nodes> {
    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/projektverwaltung/getUserNodes.php?userId=${userId}&${sessionStorage.getItem('session')}`) as Observable<
      Nodes
      >;
  }
}
